export default __webpack_public_path__ + "static/media/hot.c5754681.png";